import { useGlobalContext } from './context'
import axios from 'axios'

const MainPage = () => {
    const {  setLoading, setPlay, setImages, amount, setAmount } = useGlobalContext()
    var imgArray = [];
    var randomNums = [];
    
    //Load images in wanted amount
    async function getImages(amount) {
        setLoading(true)
        for (let i = 0; i < amount; i++) {
            while (true) {
                var randomNumber = Math.floor(Math.random() * 1000);
                if (!randomNums.includes(randomNumber)) {
                    randomNums.push(randomNumber);
                    break
                }               
            }
            await axios.get(`https://picsum.photos/id/${randomNumber}/300/`, { headers: { "Access-Control-Allow-Origin": "*" } })
            .then(res => {
              imgArray.push(res.config.url)
              imgArray.push(res.config.url)
              if (i === amount - 1)
                setImages(imgArray)
            })
            .catch(err => {
                i--;
                console.log(err)
            })
        }
        setLoading(false)
        setPlay(true)
      }

    return (
        <div className='container mt-5 w-50 text-center bg-dark rounded'>
            <h2 className='text-white font-weight-bold p-3'>Match the Pictures Game  <span className='lime'>by bergalii</span> </h2>
            <div className="container border p-3 border-white rounded">
                <div className="row">
                    <div className="col">
                        <button className='btn btn-success d-block' onClick={() => { setAmount(5); document.getElementById('difficulty').innerHTML="<span class='lime'>EZ </span> difficulty" }}>easy peasy</button>
                        <button className='btn btn-warning d-block' onClick={() => { setAmount(12); document.getElementById('difficulty').innerHTML="<span class='lime'>Meh </span> difficulty" }}>standart</button>
                        <button className='btn orange d-block' onClick={() => { setAmount(16); document.getElementById('difficulty').innerHTML="<span class='lime'>Hmm not bad </span> difficulty" }}>above average</button>
                        <button className='btn btn-danger d-block' onClick={() => { setAmount(20); document.getElementById('difficulty').innerHTML="<span class='lime'>OMG </span> difficulty" }}>will take your time</button>
                    </div>
                    <div className="col align-self-center">
                        <div className='text-white'>
                            <h3 id='difficulty' className="font-weight-bold">Select difficulty</h3>
                        </div>
                    </div>
                </div>
            </div>    
            <button style={{ width: "250px", fontSize: "22px"}} className='btn btn-light mb-2 mt-2' onClick={() => getImages(amount)}>Play</button>
        </div>
    )

}

export default MainPage;